import { TabPanels } from './TabPanels';

// TODO: in v9, move styled() from TabPanels.jsx to here
export var StyledTabPanels = TabPanels;